import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container, Grid, Typography, Box, Link } from '@mui/material';

export default class ImpressumPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      polyglot: props.polyglot,
    };
  }

  render() {
    return (
      <Container>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h2">Impressum</Typography>
            <Box mt={2}>
              <Typography variant="body1">
                ©THE ALAN NUTTALL PARTNERSHIP LTD. All rights reserved.
                <br />
                THE ALAN NUTTALL PARTNERSHIP LTD | FOODSERVICE SOLUTIONS
                <br />
                Orchard House, Dodwells Road, Hinckley, Leicestershire, United
                Kingdom LE10 3BZ
                <br />
                <br />
                [t] +44 (0) 1455 638300
                <br />
                [e]{' '}
                <Link href="mailto:info@flexeserve.com">
                  info@flexeserve.com
                </Link>
                <br />
                Group website:{' '}
                <Link href="http://www.nuttalls.co.uk">www.nuttalls.co.uk</Link>
                <br />
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    );
  }
}

ImpressumPage.propTypes = {
  polyglot: PropTypes.shape({
    t: PropTypes.func.isRequired,
  }).isRequired,
};
